(function (window, document, undefined) {
  "use strict";

  let Vue = window.Vue || false,
    logger;

  const init = function () {

    try {
      logger = new window.RussMedia.Utils.Logger("[topic page] ") || {
        log: function () {},
      };
    } catch (e) {
      logger = { log: function () {} };
    }

    if (!Vue) {
      logger.log("_init: No Vue!");
      return;
    } else {
      logger.log("Load Vue component.");
    }

    let parsedTopicData = parseTopicData();
    if (!parsedTopicData) {
      logger.log("init: No topic data.");
      return;
    }

    renderTopic(parsedTopicData);

  };

  const parseTopicData = function () {
    const topicDataNode = document.querySelector("#topicDataNode");

    let parsedTopicData = {};

    try {
      parsedTopicData = JSON.parse(topicDataNode.innerHTML) || false;
    } catch (e) {
      return false;
    }

    return parsedTopicData;
  };

  const renderTopic = (topicData) => {
    Vue.createApp({
      components: {
        TopicPage: window['@russmedia-frontend/np-topics'].TopicPage,
      },
      setup() {
        const gdprSettings = Vue.ref({
          required: false,
          marketing: false,
          tracking: false,
          preferences: false,
          granular: {},
        });

        document.addEventListener(
          "vodl_activate_embed_provider",
          function (ev) {
            let activatedProvider = ev.detail.provider || false;
            if (!activatedProvider) {
              return;
            }

            setGdpr(activatedProvider);
          }
        );

        function setGdpr(provider) {
          let newGdpr = {};

          if ("*" === provider) {
            // Full consent with alles und scharf.
            newGdpr = {
              required: true,
              marketing: true,
              tracking: true,
              preferences: true,
            };
          } else {
            // Consent for a specific provider.
            newGdpr = JSON.parse(JSON.stringify(gdprSettings.value || {}));
            newGdpr.granular = newGdpr.granular || {};
            newGdpr.granular[provider] = true;
          }

          gdprSettings.value = newGdpr;
        }

        return {
          paginationUrlConfig: topicData.paginationUrlConfig,
          hitsPage: topicData.hitsPage,
          hitsPerPage: topicData.hitsPerPage,
          prefetchedRawData: topicData.prefetchedRawData,
          topicSlug: topicData.topicSlug,
          gdprSettings
        };
      },
      template: `
        <TopicPage
          :pagination-url-config="paginationUrlConfig"
          :hits-page="hitsPage"
          :hits-per-page="hitsPerPage"
          :prefetched-raw-data="prefetchedRawData"
          :topic-slug="topicSlug"
          :gdpr-settings="gdprSettings"
        />`,
    }).mount("#vodl-page-topic");
  };

  init();
})(window, document);
